import { useMemo } from "react";

import { Maybe } from "fond/types";

import { useGetScenarioConfiguration } from "./useGetScenarioConfiguration";

interface UseProjectHasScenarioConfigurationProps {
  projectId: Maybe<string>;
}

interface UseProjectHasScenarioConfigurationReturn {
  hasConfig: boolean;
  isLoading: boolean;
}

/**
 * Return whether the given project has a scenario configuration.
 *
 * We say that a project has a scenario configuration if its root version has a scenario configuration.
 */
export const useProjectHasScenarioConfiguration = ({
  projectId,
}: UseProjectHasScenarioConfigurationProps): UseProjectHasScenarioConfigurationReturn => {
  const { configuration, isLoading } = useGetScenarioConfiguration(projectId);

  return useMemo(
    () => ({
      hasConfig: !!configuration?.ID,
      isLoading,
    }),
    [configuration?.ID, isLoading]
  );
};

export default useProjectHasScenarioConfiguration;
